import { Bot, Shield, Brain, MessageSquare } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo } from './node-chrome';
import { SaidaNomeada } from './node-saida';

export default function AIAssistantNode({ data }: any) {
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="ai_assistant"
        dados={data}
        icone={Bot}
        corDoTopo="bg-indigo-500"
        corDoIcone="text-indigo-600"
        titulo={data.label || 'Responder com IA'}
        largura="w-[240px]"
      >
        <div className="mt-2 flex items-center gap-1 flex-wrap">
          <span className="inline-flex items-center gap-1 text-[10px] font-medium text-emerald-600 bg-emerald-50 rounded px-1.5 py-0.5">
            <Shield className="w-2.5 h-2.5" /> Guardrails
          </span>
          {data.useKnowledgeBase && (
            <span className="inline-flex items-center gap-1 text-[10px] font-medium text-amber-600 bg-amber-50 rounded px-1.5 py-0.5">
              <Brain className="w-2.5 h-2.5" /> Base de conhecimento
            </span>
          )}
          {data.multiTurn && (
            <span className="inline-flex items-center gap-1 text-[10px] font-medium text-violet-600 bg-violet-50 rounded px-1.5 py-0.5">
              <MessageSquare className="w-2.5 h-2.5" /> Conversa contínua
            </span>
          )}
        </div>
        <div className="mt-2 border-t border-border/40 pt-1.5">
          <SaidaNomeada id="success" rotulo="Respondeu" cor="verde" />
          <SaidaNomeada id="fallback" rotulo="Não soube responder" cor="vermelho" />
        </div>
      </CartaoDoNo>
    </>
  );
}
